import { render, staticRenderFns } from "./wasteReportManage.vue?vue&type=template&id=4bd9c770"
import script from "./wasteReportManage.vue?vue&type=script&lang=js"
export * from "./wasteReportManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd9c770')) {
      api.createRecord('4bd9c770', component.options)
    } else {
      api.reload('4bd9c770', component.options)
    }
    module.hot.accept("./wasteReportManage.vue?vue&type=template&id=4bd9c770", function () {
      api.rerender('4bd9c770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/waste/wasteReportManage.vue"
export default component.exports